import questionMark from "../assets/img/question-mark.png";

function Instructions() {
  return (
    <div style={{ backgroundColor: "#fff", padding: "1em" }}>
      <p>Please complete all pink fields.</p>

      <p>
        When making your donation the address you enter must be an <strong>exact match</strong> for the <strong>billing address on the credit card</strong> you are using.
      </p>
      <p>This is to prevent fraudulent activity.</p>
      <p>If you need the charitable tax receipt sent to a different address, we can fix that after the donation has been processed.</p>
      <p>
        Please contact us at <a href="mailto:christmas.daddies@bellmedia.ca">christmas.daddies@bellmedia.ca</a> with the correct name & address for issuing the charitable tax receipt and include your transaction information.
      </p>

      <p>To avoid multiple transactions when submitting your donation, please:</p>

      <ul className="donateList" style={{ listStyleType: "disc !important" }}>
        <li className="li">Do not double click the Submit button</li>
        <li className="li">Do not refresh the page</li>
        <li className="li">Do not use the back button. </li>
      </ul>

      <p>The transaction may take up to a minute to complete, depending on site traffic levels. Upon completing of the transaction, you will be taken to a confirmation page.</p>

      <p>
        <strong>A charitable tax receipt can only be issued to one individual.</strong>
        <br />
        Please use only one name in the First Name field.
        <br />
        <span style={{ fontWeight: "bold" }}>Correct:</span> <strong>Elizabeth</strong>
        <br />
        <span style={{ fontWeight: "bold" }}>Incorrect:</span> <strong>Elizabeth &amp; Robert</strong>
        <br />
        The two line "TV Display" can be edited to your choosing.
      </p>

      <p style={{ marginTop: "297px" }} id="on-air-display-instructions">
        If your donation is in memory of someone or you want to change the display name, you can click the
        <img src={questionMark} style={{ float: "none", display: "inline", padding: "0", margin: "0", marginLeft: "0.25em", marginRight: "0.25em", width: "16px", height: "16px" }} alt="Question Mark Icon" />
        symbol in the form to the left to see how.
      </p>
    </div>
  );
}
export default Instructions;
